const resolveSlot = (slot) => {
  return slot && typeof slot === "function" ? slot() : slot;
};
export {
  resolveSlot as r
};
//# sourceMappingURL=resolveSlot.js.map
